import { USER_ROLES, USER_ROLE_TYPES } from '../common/constants';
import { dashboardGuard } from '../guards/dashboardGuard';
import { homeGuard } from '../guards/homeGuard';
import { validateInviteToken } from '../guards/inviteTokenValidationGuard';
import { premiumPayment } from '../guards/premiumPaymentGuard';

import { basicPayment } from '../guards/basicPaymentGuard';
import { inAppPaymentGuard } from '../guards/inAppPaymentGuard';
import { isStoryExistsGaurd } from '../guards/isStoryExistsGaurd';
import { validateResetPasswordToken } from '../guards/resetPasswordTokenValidationGuard';

const Layout = () => import(/* webpackChunkName: "layout" */ '../views/Layout.vue');
// const Home = () => import(/* webpackChunkName: "home" */ '../pages/_layout/index.vue');

export const routes = [
  // {
  //   path: '/',
  //   name: '/',
  //   component: Home,
  //   meta: { auth: true }
  // },

  // Default Routes
  {
    path: '/',
    // id: 'layout',
    component: Layout,
    children: [
      {
        path: '',
        name: 'home',
        // component: Home,
        component: Layout,
        meta: { auth: true },
        beforeEnter: (to, from, next) => {
          homeGuard(to, from, next);
        },
      },

      // Auth Routes
      {
        path: 'login',
        name: 'login',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SignIn.vue'),
      },
      {
        path: 'logout',
        name: 'logout',
        component: () => import(/* webpackChunkName: "auth" */ '../pages/_layout/logout.vue'),
      },
      {
        path: 'forgot-password',
        name: 'forgot-password',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/ForgotPass.vue'),
      },
      {
        path: 'reset-password',
        name: 'reset-password',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/ResetPassword.vue'),
        beforeEnter: validateResetPasswordToken,
      },
      {
        path: 'accept-invite',
        name: 'accept-invite',
        component: () => import(/* webpackChunkName: "std" */ '../views/Auth/AcceptInvite.vue'),
        beforeEnter: validateInviteToken,
      },
      {
        path: 'student-signup',
        name: 'student-signup',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/StudentSignUp.vue'),
        meta: { auth: false, onlyUnauth: true },
      },
      {
        path: 'employer-signup',
        name: 'employer-signup',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/EmployerSignUp.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },
      {
        path: 'verify-employer-email/:verificationId',
        name: 'verify-employer-email',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/VerifyEmployerEmail.vue'),
        meta: { auth: false },
      },
      {
        path: 'maintenance',
        // name: 'maintenance',
        // component: () => import(/* webpackChunkName: "maintenance" */ '../views/Maintenance/DownForMaintenance.vue'),
        // meta: { auth: false },
        redirect: '/',
      },
      {
        path: 'school-signup',
        // name: 'school-signup',
        redirect: 'school-interest',
        // component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SchoolSignUp.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },
      {
        path: 'school-interest',
        name: 'school-signup',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SchoolSignUp.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },
      {
        path: 'school-interest/:submission',
        name: 'verify-school-signup',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SchoolSignupSuccessComponent.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },

      {
        path: 'sponsorship-spotlight',
        name: 'sponsorship-spotlight',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SponsorshipSpotlight.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: false },
      },

      {
        path: 'manage-preference',
        name: 'manage-preference',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SubscriptionComponent.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: false },
      },
      {
        path: 'sponsorship-spotlight/:submission',
        name: 'verify-sponsorship-spotlight',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SpotlightSuccessComponent.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: false },
      },
      {
        path: 'advisor-onboarding/confirmation/:submission',
        name: 'advisor-onboarding-confirm',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Advisors/AdvisorSignupConfirm.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },
      {
        path: 'advisor-onboarding/SdwT4rYq',
        name: 'uni-advisor-onboarding',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Advisors/AdvisorSignup.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },
      {
        path: 'advisor-onboarding/:inviteId',
        name: 'org-advisor-onboarding',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Advisors/AdvisorSignup.vue'),
        meta: { auth: false, onlyUnauth: true, onlyMainDomain: true },
      },

      //Assessment Managment
      {
        path: 'assessments',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-assessments',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN],
            },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/StudentAssessments/AssessList.vue'),
          },

          {
            path: ':id',
            name: 'assessment-detail',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN],
            },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/StudentAssessments/AssessDetails.vue'),
          },
        ],
      },
      //User Resume
      {
        path: 'user-resumes',
        name: 'user-resumes-list',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/ResumeBuilder/ResumeBuilderList.vue'),
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN],
        },
      },
      //Website Config Routes
      {
        path: '/website-configuration',
        meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: Layout,
        children: [
          {
            path: 'basic',
            name: 'basic-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/WebsiteConfig/BasicPageConfig.vue'),
          },
          {
            path: 'home',
            name: 'homepage-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/WebsiteConfig/HomePageConfig.vue'),
          },
          {
            path: 'pages-config',
            name: 'pages-config',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION],
            },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/WebsiteConfig/PagesConfig.vue'),
          },
        ],
      },

      //SignUp Requests
      {
        path: 'sign-up-requests',
        name: 'manage-student-signup-list',
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.SCHOOL_OWNER] },
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/StudentSignup/StudentSignupList.vue'),
      },
      {
        path: 'sign-up-requests/:id',
        name: 'show-student-sign-up-request',
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.SCHOOL_OWNER] },
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/StudentSignup/SignUpRequestShowPage.vue'),
      },

      {
        path: 'application-form',
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
        component: Layout,
        children: [
          {
            path: 'add/:id',
            name: 'manage-in-app-form',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Applications/PostApp.vue'),
          },
          {
            path: ':sponsorship/add-section',
            name: 'add-section',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/OrganizationPortal/ApplicationFormSettings/AddSectionPage.vue'
              ),
          },
          {
            path: ':sponsorship/edit-section/:id',
            name: 'edit-section',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/OrganizationPortal/ApplicationFormSettings/AddSectionPage.vue'
              ),
          },
          {
            path: 'configure-student-info',
            name: 'configure-reg-static-fields',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/OrganizationPortal/ApplicationFormSettings/StaticFieldsPage.vue'
              ),
          },
          {
            path: ':id',
            name: 'manage-application-form',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/OrganizationPortal/ApplicationFormSettings/ManageApplicationFrom.vue'
              ),
          },
        ],
      },

      // Account/Profile Routes
      {
        path: 'my-profile',
        name: 'my-profile',
        component: () => import(/* webpackChunkName: "account" */ '../views/Account/ManageProfile.vue'),
        meta: { auth: true },
      },
      {
        path: 'change-password',
        name: 'change-password',
        component: () => import(/* webpackChunkName: "account" */ '../views/Account/ChangePass.vue'),
        meta: { auth: true },
      },
      //Partnership Route
      {
        path: 'manage-partnerships',
        name: 'manage-partnerships',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/PartnershipList.vue'),
        meta: { auth: true },
      },
      {
        path: 'manage-partnered-universities',

        name: 'manage-partnered-universities',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/UniversitiesList.vue'),
        meta: { auth: true },
      },
      {
        path: 'manage-high-school-districts',

        name: 'manage-high-school-districts',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/HighSchoolList.vue'),
        meta: { auth: true },
      },
      {
        path: 'manage-school-organizations',

        name: 'manage-school-organizations',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/OrgsList.vue'),
        meta: { auth: true },
      },
      {
        path: 'partnership-profile',
        name: 'partnership-profile',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/EditSchoolProfile.vue'),
        meta: { auth: true },
      },
      {
        path: 'spotlights',

        component: Layout,
        children: [
          {
            path: '',
            name: 'spotlight-list',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
                USER_ROLES.SCHOOL_ADMIN,
                USER_ROLES.SCHOOL_OWNER,
                USER_ROLES.SUPER_ADMIN,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/SponsorInterest/StdList.vue'),
          },
          {
            path: ':id',
            name: 'get-spotlight',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
                USER_ROLES.SCHOOL_ADMIN,
                USER_ROLES.SCHOOL_OWNER,
                USER_ROLES.SUPER_ADMIN,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/EmployerPortal/SponsorInterest/StdDetailPage.vue'),
          },
        ],
      },
      // {
      //   path: 'request-partnership',
      //   name: 'request-partnership',
      //   component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/RequestPartnershipPage.vue'),
      //   meta: { auth: true }
      // },

      // Jobs Management
      {
        path: 'manage-jobs',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [
            USER_ROLES.SUPER_ADMIN,
            USER_ROLES.EMPLOYER_ADMIN,
            USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
            USER_ROLES.ORGANIZATION,
          ],
        },
        children: [
          {
            path: '',
            name: 'jobs-management-list',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Jobs/JobsList.vue'),
          },
          {
            path: 'post',
            name: 'post-job',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Jobs/PostJob/PostJob.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-job',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Jobs/PostJob/PostJob.vue'),
          },
          {
            path: 'public-view/:id',
            name: 'manage-job-public-view',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Jobs/JobShowPage.vue'),
          },
        ],
      },

      // Research Management
      {
        path: 'manage-research',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION],
        },
        children: [
          {
            path: '',
            name: 'research-management-list',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Research/ResearchList.vue'),
          },
          {
            path: 'post',
            name: 'post-research',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Research/PostResearch/PostResearch.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-research',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Research/PostResearch/PostResearch.vue'),
          },
        ],
      },
      {
        path: 'simulations',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST],
        },
        children: [
          {
            path: 'listings',
            name: 'simulations-management-list',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Simulations/SimulationsList.vue'),
          },
          {
            path: 'add',
            name: 'post-simulation',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "gen" */ '../views/Simulations/PostSimulation/PostSimulation.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-simulation',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "gen" */ '../views/Simulations/PostSimulation/PostSimulation.vue'),
          },
          {
            path: 'submissions',
            name: 'simulations-submission-list',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN],
            },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Simulations/SimulationSubmissionList.vue'),
          },
          {
            path: 'submissions/:id',
            name: 'simulations-submission-profile',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN],
            },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/Simulations/SimulationSubmissionProfile.vue'),
          },
        ],
      },
      {
        path: 'call-logs',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER],
        },
        children: [
          {
            path: '',
            name: 'calls-logs',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER],
            },
            component: () => import(/* webpackChunkName: "adm" */ '../views/CallLogs/CallLogs.vue'),
          },
          {
            path: 'call-logs/:id',
            name: 'call-profile',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER],
            },
            component: () => import(/* webpackChunkName: "adm" */ '../views/CallLogs/CallLogProfile.vue'),
          },
        ],
      },
      {
        path: 'sponsorships',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST],
        },
        children: [
          {
            path: '',
            name: 'scholarships-management-list',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/Scholarships/ManageScholarshipsList.vue'),
          },
          {
            path: 'add',
            name: 'post-scholarship',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "gen" */ '../views/Scholarships/PostScholarship/PostScholarship.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-scholarship',
            meta: {
              auth: true,
              rolesRequired: [
                USER_ROLES.SUPER_ADMIN,
                USER_ROLES.EMPLOYER_ADMIN,
                USER_ROLES.EMPLOYER_CAREER_SPECIALIST,
                USER_ROLES.ORGANIZATION,
              ],
            },
            component: () =>
              import(/* webpackChunkName: "gen" */ '../views/Scholarships/PostScholarship/PostScholarship.vue'),
          },
          {
            path: 'submissions',
            name: 'std-apps-list',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Applications/AppList.vue'),
          },
          {
            path: 'submissions/:id',
            name: 'app-profile',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLES.EMPLOYER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Applications/AppProfile.vue'),
          },
        ],
      },
      {
        path: 'external-sponsorships',
        component: Layout,
        meta: {
          auth: true,
          rolesRequired: [USER_ROLES.SUPER_ADMIN],
        },
        children: [
          {
            path: '',
            name: 'external-scholarships-list',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN],
            },
            component: () =>
              import(/* webpackChunkName: "gen" */ '../views/ExternalScholarships/ManageScholarshipsList.vue'),
          },
          {
            path: 'add',
            name: 'post-external-scholarship',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/ExternalScholarships/PostScholarship.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-external-scholarship',
            meta: {
              auth: true,
              rolesRequired: [USER_ROLES.SUPER_ADMIN],
            },
            component: () => import(/* webpackChunkName: "gen" */ '../views/ExternalScholarships/PostScholarship.vue'),
          },
        ],
      },

      //Public Sponsorship
      {
        path: 'sponsorships/:id',
        name: 'public-scholarship',

        component: () => import(/* webpackChunkName: "std" */ '../views/PublicSholarship/PublicSchDetailPage.vue'),
      },
      //GPTs Management
      {
        path: 'gpts',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-gpts',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Gpts/ListGpts.vue'),
          },

          {
            path: 'add',
            name: 'add-gpt',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Gpts/AddGpt.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-gpt',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Gpts/AddGpt.vue'),
          },
        ],
      },
      //Test Providers Management
      {
        path: 'test-providers',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-test-providers',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TestProviders/ListTestProviders.vue'),
          },
          {
            path: 'add',
            name: 'add-test-provider',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TestProviders/AddTestProvider.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-test-provider',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TestProviders/AddTestProvider.vue'),
          },
        ],
      },
      //Users Management
      {
        path: 'users',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-users',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Users/ListUsers.vue'),
          },

          {
            path: 'add',
            name: 'add-user',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Users/PostUser.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-user',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Users/PostUser.vue'),
          },
        ],
      },

      // Payments & Billing
      {
        path: 'billing',
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
        component: Layout,
        name: 'manage-billing',
        redirect: 'billing/payment-method',
        children: [
          // Manage Payment Method
          {
            path: 'payment-method',
            name: 'manage-payment-method',
            component: () => import(/* webpackChunkName: "account" */ '../views/Payment/PaymentDetailPage.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
            beforeEnter: inAppPaymentGuard,
          },
          {
            path: 'payment-history',
            name: 'manage-payment-history',
            component: () => import(/* webpackChunkName: "account" */ '../views/Payment/PaymentHistory.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
          },
          {
            path: 'credits-history',
            name: 'manage-credits-history',
            component: () => import(/* webpackChunkName: "account" */ '../views/Payment/CreditsHistory.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.ORGANIZATION] },
          },
          {
            path: 'purchase-tokens',
            name: 'manage-purchase-tokens',
            component: () => import(/* webpackChunkName: "account" */ '../views/Payment/PurchaseTokens.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.ORGANIZATION] },
          },
        ],
      },

      //Skills
      {
        path: 'skills',
        component: Layout,
        beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'student-skill',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Skills/Skills.vue'),
          },
          {
            path: 'practice',
            name: 'student-practice-skill',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Skills/PracticeSkill.vue'),
          },
          {
            path: ':id',
            name: 'student-skill-details',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Skills/SkillDetailPage.vue'),
          },
        ],
      },

      //Ai Skills
      {
        path: 'ai-skills',
        component: Layout,
        children: [
          {
            path: '',
            name: 'ai-skill',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/SkillMap/SkillCardHome.vue'),
          },
          {
            path: 'students',
            name: 'std-ai-skill',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/SkillMap/SkillMapListing.vue'),
          },
          {
            path: 'create',
            name: 'student-create-skillmap',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/SkillMap/SkillMapForm.vue'),
          },
          {
            path: 'flashcard',
            name: 'student-flashcard',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/SkillMap/FlashCards.vue'),
          },
          // {
          //   path: ':id',
          //   name: 'student-skill-details',
          //   meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
          //   component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Skills/SkillDetailPage.vue'),
          // },
        ],
      },
      {
        path: 'skillform',
        component: Layout,
        children: [
          {
            path: 'games',
            name: 'student-skillform-games',
            component: () =>
              import(
                /* webpackChunkName: "student-skillform" */ '../views/StudentPortal/Skillform/SkillformLauncher.vue'
              ),
            meta: { auth: true },
          },
          {
            path: 'exams',
            name: 'student-skillform-exams',
            component: () =>
              import(
                /* webpackChunkName: "student-skillform" */ '../views/StudentPortal/Skillform/SkillformLauncher.vue'
              ),
            meta: { auth: true },
          },
          {
            path: 'flashcards',
            name: 'student-skillform-flashcards',
            component: () =>
              import(
                /* webpackChunkName: "student-skillform" */ '../views/StudentPortal/Skillform/SkillformLauncher.vue'
              ),
            meta: { auth: true },
          },
        ],
      },
      // Skillform Leaderboard
      {
        path: 'skillform-leaderboard',
        component: Layout,
        children: [
          {
            path: '',
            name: 'skillform-leaderboard',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Skillform/SkillformLeaderboard.vue'),
          },
        ],
      },
      //Skills
      {
        path: 'skills-configuration',
        component: Layout,
        beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'manage-skill-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ManageSkillConfig.vue'),
          },
          {
            path: 'new',
            name: 'new-skill-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ConfigureSkill.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-skill-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ConfigureSkill.vue'),
          },
        ],
      },
      // Skills Library
      {
        path: 'skills-library',
        component: Layout,
        beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'skills-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/SkillsLibrary.vue'),
          },
          {
            path: 'new',
            name: 'new-skill-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ConfigureSkillLibrary.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-skill-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ConfigureSkillLibrary.vue'),
          },
          {
            path: 'view/:id',
            name: 'view-skill-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/ViewSkillLibrary.vue'),
          },
        ],
      },
      {
        path: 'start-discussion',
        name: 'add-ques',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/AddQuestion.vue'),
      },
      {
        path: 'discussions',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'student-questions',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/QuestionList.vue'),
          },
          {
            path: ':id',
            name: 'student-question-details',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/QuesDetailPage.vue'),
          },
        ],
      },
      {
        path: 'my-discussions',

        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'my-questions',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/ManageQuesPage.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
          },

          {
            path: ':id',
            name: 'edit-ques',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/AddQuestion.vue'),
          },
        ],
      },
      {
        path: 'my-certifications',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        // beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'my-certifications',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Certificates/CertificatesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-certificate',
            name: 'add-certificate',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Certificates/AddCertificate.vue'),
          },
          {
            path: ':id',
            name: 'edit-certificate',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Certificates/AddCertificate.vue'),
          },
        ],
      },
      {
        path: 'my-offers',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: dashboardGuard,
        children: [
          {
            path: '',
            name: 'my-offers',
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Offers/OffersList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-offer',
            name: 'add-offer',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Offers/AddOffer.vue'),
          },
          {
            path: ':id',
            name: 'edit-offer',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Offers/AddOffer.vue'),
          },
        ],
      },
      {
        path: 'my-research',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: dashboardGuard,
        children: [
          {
            path: '',
            name: 'my-research',
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Research/ResearchList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-research',
            name: 'add-research',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Research/AddResearch.vue'),
          },
          {
            path: ':id',
            name: 'edit-research',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Research/AddResearch.vue'),
          },
        ],
      },
      {
        path: 'my-courses',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        // beforeEnter: dashboardGuard,
        children: [
          {
            path: '',
            name: 'my-courses',
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Courses/CoursesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-course',
            name: 'add-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Courses/AddCourse.vue'),
          },
          {
            path: ':id',
            name: 'edit-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Courses/AddCourse.vue'),
          },
        ],
      },
      {
        path: 'my-letters-of-recommendation',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-letters-of-recommendation',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/LettersOfRecommendation/LettersOfRecommendationList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-letter-of-recommendation',
            name: 'add-letter-of-recommendation',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/LettersOfRecommendation/AddLetterOfRecommendation.vue'),
          },
          {
            path: ':id',
            name: 'edit-letter-of-recommendation',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/LettersOfRecommendation/AddLetterOfRecommendation.vue'),
          },
        ],
      },
      {
        path: 'my-activities',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-activities',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Activities/ActivitiesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-activity',
            name: 'add-activity',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Activities/AddActivity.vue'),
          },
          {
            path: ':id',
            name: 'edit-activity',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Activities/AddActivity.vue'),
          },
        ],
      },
      {
        path: 'my-admissions-assessments',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-admissions-assessments',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/AdmissionsAssessments/AdmissionsAssessmentsList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-admissions-assessment',
            name: 'add-admissions-assessment',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/AdmissionsAssessments/AddAdmissionsAssessment.vue'),
          },
          {
            path: ':id',
            name: 'edit-admissions-assessment',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/AdmissionsAssessments/AddAdmissionsAssessment.vue'),
          },
        ],
      },
      {
        path: 'my-licenses',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-licenses',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Licenses/LicensesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-license',
            name: 'add-license',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Licenses/AddLicense.vue'),
          },
          {
            path: ':id',
            name: 'edit-license',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Licenses/AddLicense.vue'),
          },
        ],
      },
      {
        path: 'my-degrees',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-degrees',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Degrees/DegreesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-degree',
            name: 'add-degree',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Degrees/AddDegree.vue'),
          },
          {
            path: ':id',
            name: 'edit-degree',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Degrees/AddDegree.vue'),
          },
        ],
      },
      {
        path: 'my-prep-courses',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        children: [
          {
            path: '',
            name: 'my-prep-courses',
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/PrepCourses/PrepCoursesList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
          },
          {
            path: 'add-prep-course',
            name: 'add-prep-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/PrepCourses/AddPrepCourse.vue'),
          },
          {
            path: ':id',
            name: 'edit-prep-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/PrepCourses/AddPrepCourse.vue'),
          },
        ],
      },

      // Employer pages redirection.
      {
        path: 'redirect-employer',
        component: Layout,
        children: [
          {
            path: '',
            name: 'redirect-employer',
            component: () => import(/* webpackChunkName: "std" */ '../views/Employers/RedirectEmployers.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
          },
          {
            path: ':id',
            name: 'redirect-employer-profile',
            component: () => import(/* webpackChunkName: "std" */ '../views/Employers/RedirectEmployers.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
          },
        ],
      },
    ],
  },

  // Super Admin Management Routes
  {
    path: '/admin',
    meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
    component: Layout,
    children: [
      // Dashboard/Home
      {
        path: 'dashboard',
        name: 'admin-dashboard',
        component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Dashboard/Dashboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
      },
      {
        path: 'manage-all-partnerships',
        name: 'manage-all-partnerships',
        meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Partnerships/PartnershipsList.vue'),
      },
      {
        path: 'feature-updates',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-features',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/FeatureUpdates/ManageFeatureUpdates.vue'),
          },
          {
            path: 'add',
            name: 'add-features',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/FeatureUpdates/AddFeatureUpdate.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-features',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/FeatureUpdates/AddFeatureUpdate.vue'),
          },
        ],
      },
      {
        path: 'interested-schools',
        component: Layout,
        children: [
          {
            path: 'approve-interested-school',
            name: 'add-interested-school',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/PostSchool.vue'),
          },
          {
            path: '',
            name: 'manage-interested-schools',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/ListInterestedSchools.vue'),
          },
          {
            path: ':id',
            name: 'interested-school-profile',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/InterestedSchoolProfile.vue'),
          },
        ],
      },
      // Schools Management
      {
        path: 'schools',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-schools',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/ListSchools.vue'),
          },
          {
            path: 'add',
            name: 'add-school',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/PostSchool.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-school',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Schools/PostSchool.vue'),
          },
        ],
      },

      // Schools Management
      {
        path: 'partners',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-partners',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Partners/ListPartners.vue'),
          },
          {
            path: 'add',
            name: 'add-partner',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Partners/PostPartner.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-partner',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Partners/PostPartner.vue'),
          },
        ],
      },
      // University Management
      {
        path: 'sponsored-training/universities',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-unis',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Universities/ListUnis.vue'),
          },
          {
            path: 'add',
            name: 'add-uni',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Universities/PostUniversity.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-uni',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Universities/PostUniversity.vue'),
          },
        ],
      },

      // Credential Pathways Management
      {
        path: 'sponsored-training/pathways',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-pathways',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Pathways/ListPathways.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-pathway',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Pathways/PostPathway.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-pathway',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Pathways/PostPathway.vue'),
          },
        ],
      },

      // Student societies (TransitionU)
      {
        path: 'sponsored-training/societies',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-societies',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Societies/ListSocieties.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-society',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Societies/PostSociety.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-society',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Societies/PostSociety.vue'),
          },
        ],
      },

      // TransitionU home page testimonials
      {
        path: 'sponsored-training/testimonials',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-tu-testimonials',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TuTestimonials/ListTuTestimonials.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-tu-testimonial',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TuTestimonials/PostTuTestimonial.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-tu-testimonial',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/TuTestimonials/PostTuTestimonial.vue'),
          },
        ],
      },

      // Pathway Leads (read-only — captured on carecampus marketing site)
      {
        path: 'sponsored-training/pathway-leads',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-pathway-leads',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Pathways/ListPathwayLeads.vue'),
          },
        ],
      },

      // Pathway Enrollments (read-only)
      {
        path: 'sponsored-training/pathway-enrollments',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-pathway-enrollments',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Pathways/ListPathwayEnrollments.vue'),
          },
        ],
      },

      // Organization Management
      {
        path: 'organizations',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-organizations',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Organizations/ListOrganizations.vue'),
          },
          {
            path: 'add',
            name: 'add-organization',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Organizations/PostOrganization.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-organization',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Organizations/PostOrganization.vue'),
          },
        ],
      },

      // Prize Management
      {
        path: 'prize',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-prize',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Prize/ListPrize.vue'),
          },
          {
            path: 'manage-redeem-prizes',
            name: 'manage-redeem-prizes',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Prize/ListRedeemedPrize.vue'),
          },
          {
            path: 'add',
            name: 'add-prize',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Prize/PostPrize.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-prize',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Prize/PostPrize.vue'),
          },
        ],
      },

      // Students Management
      {
        path: 'students',
        component: Layout,
        children: [
          {
            path: 'progress-analytics',
            name: 'sa-student-progress-analytics',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Analytics/LmsSuperAnalytics.vue'),
          },
          {
            path: '',
            name: 'manage-students',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Students/ListStudents.vue'),
          },
          {
            path: 'add',
            name: 'add-student',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Students/PostStudent.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-student',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Students/PostStudent.vue'),
          },
        ],
      },

      // Employers Management
      {
        path: 'employers',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-employers',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Employers/ListEmployers.vue'),
          },
          {
            path: 'add',
            name: 'add-employer',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Employers/PostEmployer.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-employer',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Employers/PostEmployer.vue'),
          },
        ],
      },

      // Career Preferences Management
      {
        path: 'career-pathways',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-career-pathways',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/CareerPreferences/ListCareerPathways.vue'
              ),
          },
          {
            path: 'add',
            name: 'sa-add-career-pathway',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/CareerPreferences/PostCareerPreference.vue'
              ),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-career-pathway',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/CareerPreferences/PostCareerPreference.vue'
              ),
          },
        ],
      },
      //Programs Management
      {
        path: 'programs',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-programs',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Programs/ProgramList.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-program',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Programs/PostProgram.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-program',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Programs/PostProgram.vue'),
          },
        ],
      },

      //LMS Management
      {
        path: 'lms/courses',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-list-courses',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Courses/ListCourses.vue'),
          },
          {
            path: 'add',
            name: 'sa-create-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Courses/PostCourse.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-lms-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Courses/PostCourse.vue'),
          },
        ],
      },
      {
        path: 'lms/chapters',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-list-lectures',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Chapters/ListChapters.vue'),
          },
          {
            path: 'add',
            name: 'sa-create-chapter',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Chapters/PostChapter.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-chapter',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Chapters/PostChapter.vue'),
          },
        ],
      },
      {
        path: 'lms/quizzes',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-list-quizzes',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Quiz/ListQuizzes.vue'),
          },
          {
            path: 'add',
            name: 'sa-create-quiz',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Quiz/PostQuiz.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-quiz',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Quiz/PostQuiz.vue'),
          },
        ],
      },
      {
        path: 'lms/assignments',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-list-assignments',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Assignments/ListAssignments.vue'),
          },
          {
            path: 'add',
            name: 'sa-create-assignment',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Assignments/PostAssignments.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-assignment',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Assignments/PostAssignments.vue'),
          },
        ],
      },
      {
        path: 'lms/ai-provider-config',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-ai-provider-config',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/AiProviderConfig/AiProviderConfig.vue'),
          },
        ],
      },
      {
        path: 'lms/library',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-skills-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsLibrary/ListSkillsLibrary.vue'),
          },
          {
            path: 'add',
            name: 'sa-new-skill-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsLibrary/ConfigureSkillLibrary.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-skill-library',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsLibrary/ConfigureSkillLibrary.vue'),
          },
        ],
      },
      {
        path: 'lms/enrollments',
        name: 'sa-course-enrollments',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/CourseEnrollments/ListCourseEnrollment.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SUPER_ADMIN] },
      },
      {
        path: 'lms/enrollments/:enrollmentId/gradebook',
        name: 'sa-course-enrollment-gradebook',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/CourseEnrollments/CourseEnrollmentGradebook.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SUPER_ADMIN] },
      },

      //Blog Management
      {
        path: 'blog',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-blogs',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Blogs/ListBlog.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-blog',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Blogs/AddBlog.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-blog',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Blogs/AddBlog.vue'),
          },
        ],
      },
      //Resources Management
      {
        path: 'manage-resources',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-resources',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/ListResources.vue'),
          },
          {
            path: 'add',
            name: 'add-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/AddResource.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/AddResource.vue'),
          },
        ],
      },
      //SkillMap Management
      {
        path: 'skill-map',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-skillmaps',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillMap/ListSkillMap.vue'),
          },
          {
            path: 'add',
            name: 'add-skillmap',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillMap/AddSkillMap.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-skillmap',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillMap/AddSkillMap.vue'),
          },
        ],
      },
      // Skills Competitions Management
      {
        path: 'skills-competitions',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-skills-competitions-list',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsCompetitions/SkillsCompetitionsList.vue'
              ),
          },
          {
            path: 'add',
            name: 'sa-add-skills-competition',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsCompetitions/PostSkillsCompetition.vue'
              ),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-skills-competition',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsCompetitions/PostSkillsCompetition.vue'
              ),
          },
          {
            path: 'view/:id',
            name: 'sa-view-skills-competition',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SkillsCompetitions/PostSkillsCompetition.vue'
              ),
          },
        ],
      },
      // Events Management
      {
        path: 'events',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-events',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Events/ListEvents.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-event',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Events/PostEvent.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-event',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Events/PostEvent.vue'),
          },
        ],
      },
      //Connnections
      {
        path: 'sponsored-training/connect-requests',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-connections',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Connections/ListConnections.vue'),
          },
        ],
      },
      //Best School States
      {
        path: 'sponsored-training/best-school-states',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-states',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/ListStates.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-state',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/AddState.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-state',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/AddState.vue'),
          },
        ],
      },
      //Best School Cities
      {
        path: 'sponsored-training/high-school-districts',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-cities',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/ListCity.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-city',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/AddCity.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-city',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/BestSchoolLocation/AddCity.vue'),
          },
        ],
      },

      {
        path: 'system-config',
        name: 'system-config',
        meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
        component: () =>
          import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/SystemConfig/SystemConfig.vue'),
      },

      // Advisors
      {
        path: 'advisors',
        component: Layout,
        children: [
          {
            path: '',
            name: 'sa-manage-advisors',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Advisors/ManageAdvisors.vue'),
          },
          {
            path: 'add',
            name: 'sa-add-advisor',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Advisors/PostAdvisor.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sa-edit-advisor',
            meta: { auth: true, rolesRequired: [USER_ROLES.SUPER_ADMIN] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/Advisors/PostAdvisor.vue'),
          },
        ],
      },
    ],
  },
  //Organization Portal
  {
    path: '/organization',
    meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION] },
    component: Layout,
    name: 'organization-home',

    redirect: 'organization/dashboard',

    children: [
      //School Profile
      {
        path: 'org-profile',
        name: 'manage-org-profile',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Profile/ManageOrgProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'dashboard',
        name: 'org-admin-home',
        component: () => import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Dashboard/Dashboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'manage-student-dashboard',
        name: 'manage-org-student-dashboard',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Profile/ManageStudentDashboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'analytics',
        name: 'org-analytics',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Analytics/ParticipantAnalytics.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'setup-guide',
        name: 'org-setup-guide',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/SetupGuide/OrgSetupGuide.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      // Schools
      {
        path: 'schools',
        name: 'org-schools-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Schools/Schools.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'schools/:id',
        name: 'org-school-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Schools/SchoolProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'candidates',
        name: 'org-students-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/Students.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'unlock-candidates',
        name: 'org-unlock-students-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/Students.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'unlock-candidates/:id',
        name: 'org-unlocked-candidate-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },

      {
        path: 'associated-candidates',
        name: 'associated-students-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/Students.vue'),
        meta: {
          auth: true,
          rolesRequired: [
            USER_ROLES.ORGANIZATION,
            USER_ROLE_TYPES.ORGANIZATION,
            USER_ROLES.EMPLOYER_ADMIN,
            USER_ROLE_TYPES.EMPLOYER,
          ],
        },
      },
      {
        path: 'associated-candidates/:id',
        name: 'associated-candidate-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/StudentProfile.vue'),
        meta: {
          auth: true,
          rolesRequired: [
            USER_ROLES.ORGANIZATION,
            USER_ROLE_TYPES.ORGANIZATION,
            USER_ROLES.EMPLOYER_ADMIN,
            USER_ROLE_TYPES.EMPLOYER,
          ],
        },
      },

      {
        path: 'candidates/:id',
        name: 'org-student-details',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
      },
      {
        path: 'events',
        component: Layout,
        redirect: 'events/',

        children: [
          {
            path: '',
            name: 'manage-org-events',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/Events/EventsList.vue'),
          },
          {
            path: 'add',
            name: 'add-org-event',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Events/PostEvent.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-org-event',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Events/PostEvent.vue'),
          },
        ],
      },
      {
        // Verifications workspace: Exam Results / Licenses bucket tabs over each page.
        path: 'verifications',
        component: Layout,
        children: [
          {
            path: '',
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/Verifications/VerificationsWorkspace.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            children: [
              {
                path: '',
                name: 'org-exam-results',
                meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
                component: () =>
                  import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/ExamResults/ListExamResults.vue'),
              },
              {
                path: 'licenses',
                name: 'org-license-verifications',
                meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
                component: () =>
                  import(
                    /* webpackChunkName: "adm" */ '../views/OrganizationPortal/LicenseVerifications/ListLicenseVerifications.vue'
                  ),
              },
            ],
          },
        ],
      },
      {
        path: 'resources',
        component: Layout,
        redirect: 'resources/',

        children: [
          {
            path: '',
            name: 'manage-org-resources',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/Resource/ListResource.vue'),
          },
          {
            path: 'add',
            name: 'add-org-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/Resource/AddResource.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-org-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/OrganizationPortal/Resource/AddResource.vue'),
          },
        ],
      },

      {
        path: 'employers',
        component: Layout,
        redirect: 'employers/',

        children: [
          {
            path: '',
            name: 'manage-org-employers',
            component: () =>
              import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Employers/EmployersList.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
          },
          {
            path: 'edit/:id',
            name: 'edit-org-employer',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Employers/PostEmployer.vue'),
          },
          {
            path: 'public-profile/:id',
            name: 'org-emp-public-profile',
            component: () => import(/* webpackChunkName: "emp" */ '../views/Employers/EmployerProfile.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
          },
        ],
      },

      {
        path: 'custom-questions',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-questions',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Questions/QuestionsList.vue'),
          },
          {
            path: 'add',
            name: 'add-question',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/OrganizationPortal/Questions/PostQuestion.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-question',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/OrganizationPortal/Questions/PostQuestion.vue'),
          },
        ],
      },

      {
        path: 'inquiries',
        component: Layout,
        children: [
          {
            path: '',
            name: 'org-inquiries-list',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "org-inq" */ '../views/OrganizationPortal/Inquiries/InquiriesList.vue'),
          },
          {
            path: ':id',
            name: 'org-inquiry-details',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "org-inq" */ '../views/OrganizationPortal/Inquiries/InquiryDetails.vue'),
          },
        ],
      },

      {
        path: 'advisors',
        component: Layout,
        children: [
          {
            path: '',
            name: 'manage-org-advisors',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "org-inq" */ '../views/Advisors/ManageAdvisors.vue'),
          },
          {
            path: 'add',
            name: 'add-org-advisor',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "org-inq" */ '../views/Advisors/PostAdvisor.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-org-advisor',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "org-inq" */ '../views/Advisors/PostAdvisor.vue'),
          },
        ],
      },
      {
        path: 'discussions',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
        // beforeEnter: premiumPayment,
        children: [
          {
            path: '',
            name: 'org-questions-list',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/QuestionList.vue'),
          },
          {
            path: 'add',
            name: 'org-add-discussion',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/AddQuestion.vue'),
          },
          {
            path: 'edit/:id',
            name: 'org-edit-discussion',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/AddQuestion.vue'),
          },
          {
            path: 'my-discussions',
            name: 'org-my-discussions',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/ManageQuesPage.vue'),
          },
          {
            path: ':id',
            name: 'org-discussion-details',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/QuesDetailPage.vue'),
          },
        ],
      },
      {
        path: 'bulk-messaging',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
        children: [
          {
            path: '',
            name: 'org-bulk-messaging',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(
                /* webpackChunkName: "org-bulk" */ '../views/OrganizationPortal/BulkMessaging/BulkMessagingList.vue'
              ),
          },
        ],
      },
      {
        path: 'bulk-sms-messaging',
        component: Layout,
        meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
        children: [
          {
            path: '',
            name: 'org-bulk-sms-messaging',
            meta: { auth: true, rolesRequired: [USER_ROLES.ORGANIZATION, USER_ROLE_TYPES.ORGANIZATION] },
            component: () =>
              import(
                /* webpackChunkName: "org-bulk-sms" */ '../views/OrganizationPortal/BulkMessaging/BulkMessagingSmsList.vue'
              ),
          },
        ],
      },
    ],
  },

  // School Portal Routes
  {
    path: '/school',
    meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
    component: Layout,
    name: 'school-home',
    redirect: 'school/dashboard',
    children: [
      //School Profile
      {
        path: 'dashboard',
        name: 'dashboard-school',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        component: () => import(/* webpackChunkName: "adm" */ '../views/SchoolPortal/dashboard/SchoolDashboard.vue'),
      },
      {
        path: 'integrations',
        name: 'school-integrations',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        component: () => import(/* webpackChunkName: "adm" */ '../views/SchoolPortal/Integrations/Integrations.vue'),
      },
      {
        path: 'school-profile',
        name: 'manage-school-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/SchoolPortal/Profile/ManageSchoolProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'student-dashboard',
        name: 'manage-student-dashboard',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/SchoolPortal/Profile/ManageStudentDashboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'school-profile/public-view',
        name: 'school-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Schools/SchoolProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },

      // Students
      {
        path: 'students',
        name: 'schl-students-list',
        component: () => import(/* webpackChunkName: "sch" */ '../views/Students/Students.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'configure-student-docs',
        name: 'configure-student-docs',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Settings/ConfigurePiisPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'secure-docs',
        name: 'schl-std-secure-docs',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/SecureDocs/StdSecureDocsList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'generate-report',
        name: 'generate-report',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/SecureDocs/ReportGenPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },

      // Exam Results
      {
        path: 'exam-results',
        name: 'school-exam-results',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/ExamResults/ListExamResults.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'exam-results/add',
        name: 'add-exam-result',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/ExamResults/AddExamResult.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'exam-results/edit/:id',
        name: 'edit-exam-result',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/ExamResults/AddExamResult.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },

      {
        path: 'students/:id',
        name: 'schl-student-profile',
        component: () => import(/* webpackChunkName: "sch" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'students/skill/:id',
        name: 'schl-student-skill-detail',
        component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/SkillDetailPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },

      // Prizes/Rewards
      {
        path: 'redeem-rewards',
        name: 'redeem-rewards',
        component: () => import(/* webpackChunkName: "sch" */ '../views/Payment/RedeemCredits.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },

      {
        path: 'rewards/redemption-history',
        name: 'sch-prize-redemption-history',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () => import(/* webpackChunkName: "adm" */ '../views/Payment/PrizeCreditsHistory.vue'),
      },

      //Free Plan Pages
      {
        path: 'upgrade-plan',
        name: 'upgrade-plan',
        component: () => import(/* webpackChunkName: "auth" */ '../views/SchoolPortal/UpgradePlan/UpgradePlanPage.vue'),
      },
      // Employers
      // {
      //   path: 'employers',
      //   name: 'schl-employers-list',
      //   component: () => import(/* webpackChunkName: "sch" */ '../views/Employers/Employers.vue'),
      //   meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] }
      // },
      {
        path: 'employers/:id',
        name: 'schl-employer-profile',
        component: () => import(/* webpackChunkName: "sch" */ '../views/Employers/EmployerProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      //Invites
      {
        path: 'manage-invites/send-invite',
        name: 'manage-student-invites',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER] },
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/InviteStudents/PostInvite.vue'),
      },
      {
        path: 'manage-invites',
        name: 'manage-student-invite-list',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER] },
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/InviteStudents/InviteList.vue'),
      },
      //Testimonials
      {
        path: 'testimonials',
        name: 'manage-student-testimonial-list',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Testimonials/TestimonialList.vue'),
      },
      {
        path: 'testimonials/:id',
        name: 'show-student-testimonial',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Testimonials/TestimonialShowPage.vue'),
      },
      {
        path: 'skillcards',
        name: 'show-student-skillcard',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/SkillCard/SkillCardList.vue'),
      },
      //SignUp Requests
      // {
      //   path: 'sign-up-requests',
      //   name: 'manage-student-signup-list',
      //   meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER] },
      //   component: () =>
      //     import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/StudentSignup/StudentSignupList.vue'),
      // },
      // {
      //   path: 'sign-up-requests/:id',
      //   name: 'show-student-sign-up-request',
      //   meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER] },
      //   component: () =>
      //     import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/StudentSignup/SignUpRequestShowPage.vue'),
      // },

      // Request Partnership (use if needed)
      // {
      //   path: 'employers/request-partnership/:id',
      //   name: 'school-request-partnership',
      //   component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/RequestPartnershipPage.vue'),
      //   meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER] }
      // }

      //Resources Management
      {
        path: 'resources',
        component: Layout,
        children: [
          {
            path: '',
            name: 'school-manage-resources',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/ListResources.vue'),
          },
          {
            path: 'add',
            name: 'sch-add-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/AddResource.vue'),
          },
          {
            path: 'edit/:id',
            name: 'sch-edit-resource',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "adm" */ '../views/SuperAdminPortal/Resources/AddResource.vue'),
          },
        ],
      },
      {
        path: 'feature-updates',
        name: 'feature-updates-page',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/FeatureUpdates/FeatureUpdates.vue'),
      },
      {
        path: 'feature-updates/:id',
        name: 'feature-update-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/FeatureUpdates/FeatureUpdateDetails.vue'),
      },
      {
        path: 'lms',
        name: 'lms-disabled',
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsDisabled/LmsDisabled.vue'),
      },
      {
        path: 'lms/lectures',
        component: Layout,
        children: [
          {
            path: '',
            name: 'list-lectures',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Chapters/ListChapters.vue'),
          },
          {
            path: 'add',
            name: 'create-lecture',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Chapters/PostChapter.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-lecture',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Chapters/PostChapter.vue'),
          },
        ],
      },
      {
        path: 'lms/quizzes',
        component: Layout,
        children: [
          {
            path: 'all',
            name: 'list-quizzes',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/ListQuizzes.vue'),
          },
          {
            path: 'submissions',
            name: 'list-quiz-submissions',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/ListQuizSubmissions.vue'),
          },
          {
            path: 'add',
            name: 'create-quiz',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/PostQuiz.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-quiz',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/PostQuiz.vue'),
          },
        ],
      },
      {
        path: 'lms/assignments',
        component: Layout,
        children: [
          {
            path: '',
            name: 'list-assignments',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Assignments/ListAssignments.vue'),
          },
          {
            path: 'add',
            name: 'create-assignment',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Assignments/PostAssignments.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-assignment',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Assignments/PostAssignments.vue'),
          },
        ],
      },
      {
        path: 'lms/graded-submissions',
        component: Layout,
        children: [
          {
            path: '',
            name: 'list-graded-submissions',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/GradedSubmissions/ListGradedSubmissions.vue'),
          },
          {
            path: 'grade/:id',
            name: 'grade-submission',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/GradedSubmissions/GradeSubmission.vue'),
          },
          {
            path: 'simple/:id',
            name: 'simple-submission-detail',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () =>
              import(
                /* webpackChunkName: "sch" */ '../views/SchoolPortal/GradedSubmissions/SimpleSubmissionDetail.vue'
              ),
          },
        ],
      },
      {
        path: 'lms/courses',
        component: Layout,
        children: [
          {
            path: '',
            name: 'list-courses',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/ListCourses.vue'),
          },
          {
            path: 'add',
            name: 'create-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/PostCourse.vue'),
          },
          {
            path: 'edit/:id',
            name: 'edit-lms-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/PostCourse.vue'),
          },
          {
            path: 'view/:id',
            name: 'view-lms-course',
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
            component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/ViewCourse.vue'),
          },
        ],
      },
      {
        path: 'lms/enrollments',
        name: 'course-enrollments',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/CourseEnrollments/ListCourseEnrollment.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SUPER_ADMIN] },
      },
      {
        path: 'email-configs',
        name: 'email-config-list',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/EmailConfigs/ListEmailConfigs.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'email-configs/logs',
        name: 'email-config-logs',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/EmailConfigs/EmailConfigLogs.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'email-configs/:id',
        name: 'edit-email-config',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/EmailConfigs/EditEmailConfig.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/courses/:id/analytics',
        name: 'course-analytics',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/CourseAnalytics.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        // Reporting workspace: the shell adds the LMS / Assessments /
        // Assignments buckets, each bucket renders its page unchanged.
        path: 'lms/analytics',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsAnalytics/ReportingWorkspace.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        children: [
          {
            path: '',
            name: 'school-lms-analytics',
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsAnalytics/SchoolLmsAnalytics.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
          },
          {
            path: 'assessments',
            name: 'school-lms-assessment-reporting',
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsAnalytics/AssessmentReporting.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
          },
          {
            path: 'assignments',
            name: 'school-lms-assignment-analytics',
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsAnalytics/AssignmentAnalytics.vue'),
            meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
          },
        ],
      },
      {
        // Reached from the button on the LMS bucket, not a bucket itself.
        path: 'lms/analytics/leaderboard',
        name: 'school-lms-leaderboard',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/LmsAnalytics/CourseLeaderboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/courses/:id/gradebook',
        name: 'course-gradebook',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/CourseGradebook.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/courses/:courseId/cohort/:tagId/config',
        name: 'cohort-config',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Courses/CohortConfig.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/enrollments/:enrollmentId/gradebook',
        name: 'course-enrollment-gradebook',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/CourseEnrollments/CourseEnrollmentGradebook.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SUPER_ADMIN] },
      },
      {
        path: 'lms/enrollments/:enrollmentId/quizzes/:quizId/attempts',
        name: 'quiz-attempts',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/QuizAttempts.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/quizzes/:quizId/attempts',
        name: 'quiz-attempts-direct',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Quiz/QuizAttempts.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'lms/enrollments/:enrollmentId/assignments/:assignmentId/attempts',
        name: 'assignment-attempts',
        component: () =>
          import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Assignments/AssignmentAttempts.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
      {
        path: 'mark-attendance',
        name: 'mark-attendance',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Attendance/MarkAttendance.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        beforeEnter: basicPayment,
      },

      {
        path: 'edit-attendance',
        name: 'edit-attendance',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Attendance/MarkAttendance.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        beforeEnter: basicPayment,
      },

      {
        path: 'view-attendance',
        name: 'view-attendance',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Attendance/ViewAttendance.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
        beforeEnter: basicPayment,
      },

      {
        path: 'manage-tags',
        name: 'manage-tags',
        component: () => import(/* webpackChunkName: "sch" */ '../views/SchoolPortal/Tags/ManageTags.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.SCHOOL_OWNER, USER_ROLES.SCHOOL_ADMIN] },
      },
    ],
  },

  // Employer Portal Routes
  {
    path: '/employer',
    meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
    component: Layout,
    name: 'employer-home',
    redirect: 'employer/dashboard',
    children: [
      // Company Profile Management
      {
        path: 'company-profile',
        name: 'manage-company-profile',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Profile/ManageEmployerProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
      },
      {
        path: 'setup-guide',
        name: 'employer-setup-guide',
        component: () =>
          import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/SetupGuide/EmployerSetupGuide.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
      },
      {
        path: 'dashboard',
        name: 'dashboard-employer',
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
        component: () => import(/* webpackChunkName: "adm" */ '../views/Employers/Dashboard/EmployerDashboard.vue'),
      },

      {
        path: 'company-profile/public-view',
        name: 'emp-public-company-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Employers/EmployerProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN] },
      },

      // Candidates / Students
      {
        path: 'candidates',
        name: 'employer-candidates-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/Students.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'unlocked-candidates',
        name: 'employer-unlocked-candidates-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/Students.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'unlocked-candidates/:id',
        name: 'employer-unlocked-candidate-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'candidates/:id',
        name: 'employer-candidate-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'candidates/skill/:id',
        name: 'emp-candidate-skill-detail',
        component: () => import(/* webpackChunkName: "sch" */ '../views/StudentPortal/Skills/SkillDetailPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },

      // Schools
      {
        path: 'schools',
        name: 'emp-schools-list',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Schools/Schools.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'schools/:id',
        name: 'emp-school-profile',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Schools/SchoolProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      //Partnership
      {
        path: 'schools/request-partnership/:id',
        name: 'employer-request-partnership',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/RequestPartnershipPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'schools/partnership-terms/:id',
        name: 'emp-school-partnership-terms',
        component: () => import(/* webpackChunkName: "account" */ '../views/Partnership/PartnershipTermsPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      //Hire
      {
        path: 'hires',
        name: 'hires',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Hire/HiresList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },
      {
        path: 'hires/make-a-hire',
        name: 'make-a-hire',
        component: () => import(/* webpackChunkName: "emp" */ '../views/EmployerPortal/Hire/PostHire.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
      },

      {
        path: 'custom-questions',
        component: Layout,
        children: [
          {
            path: '',
            name: 'emp-manage-questions',
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
            component: () =>
              import(/* webpackChunkName: "emp" */ '../views/OrganizationPortal/Questions/QuestionsList.vue'),
          },
          {
            path: 'add',
            name: 'emp-add-question',
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/OrganizationPortal/Questions/PostQuestion.vue'),
          },
          {
            path: 'edit/:id',
            name: 'emp-edit-question',
            meta: { auth: true, rolesRequired: [USER_ROLES.EMPLOYER_ADMIN, USER_ROLES.EMPLOYER_CAREER_SPECIALIST] },
            component: () =>
              import(/* webpackChunkName: "sch" */ '../views/OrganizationPortal/Questions/PostQuestion.vue'),
          },
        ],
      },
    ],
  },

  // Partner Portal Routes
  {
    path: '/partner',
    meta: { auth: true, rolesRequired: [USER_ROLES.PARTNER] },
    component: Layout,
    name: 'partner-home',
    redirect: 'partner/jobs',
    children: [
      {
        path: 'jobs',
        name: 'partner-jobs-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.PARTNER] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Partners/Jobs/JobsListing.vue'),
      },
      {
        path: 'jobs/:id',
        name: 'partner-job-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.PARTNER] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Jobs/JobShowPage.vue'),
      },
    ],
  },

  // Student Portal Routes
  {
    path: '/student',
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    component: Layout,
    name: 'student-home',
    redirect: 'student/home',
    children: [
      // Dashboard
      {
        path: 'home',
        name: 'student-dashboard',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/Dashboard.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'university-checklist/:slug',
        name: 'std-cc-uni-checklist',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/CareCampusUniChecklist.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'university-checklist/:slug/detail',
        name: 'std-cc-uni-checklist-detail',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/CareCampusUniChecklistDetail.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'institutions',
        name: 'student-institutions',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/DashUniversitiesList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'myinfo',
        name: 'student-info',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/MyInfo/MyInfo.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'dashboard/:categoryType',
        name: 'category-detail',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/CategoryDetail.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        props: true,
      },
      {
        path: 'simulations',
        name: 'student-simulations',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/DashSimulationList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'pathways',
        name: 'student-pathways',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Pathways/PathwaysList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'pathways/:id',
        name: 'student-pathway-detail',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Pathways/PathwayDetail.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'programs/:uniSlug/:programSlug',
        name: 'student-program-detail',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Programs/ProgramDetail.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'programs',
        name: 'student-programs',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Programs/ProgramsList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'advisors',
        name: 'student-advisors',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Advisor/AdvisorList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'checklist',
        name: 'student-checklist',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Dashboard/OrgChecklist.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'discussions',
        name: 'student-discussions',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Questions/QuestionList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'advisors/:id',
        name: 'student-advisor-profile',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Advisor/AdvisorProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'sponsorship-spotlight',
        name: 'student-sponsorship-spotlight',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SponsorshipSpotlight.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: isStoryExistsGaurd,
      },

      {
        path: 'sponsorship-spotlight/:submission',
        name: 'verify-student-sponsorship-spotlight',
        component: () => import(/* webpackChunkName: "auth" */ '../views/Auth/SpotlightSuccessComponent.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      {
        path: 'manage-sponsorship-spotlight',
        name: 'update-sponsorship-spotlight',
        component: () =>
          import(/* webpackChunkName: "auth" */ '../views/StudentPortal/Scholarships/SponsorshipSpotlightUpdate.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: isStoryExistsGaurd,
      },

      //Community
      {
        path: 'resources',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: Layout,
        children: [
          {
            path: '',
            name: 'student-community',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Community/Community.vue'),
          },
          {
            path: ':slug',
            name: 'resource-detail',
            meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
            component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Community/ResourcePage.vue'),
          },
        ],
      },
      // Onboarding
      {
        path: 'onboarding',
        name: 'student-onboarding',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Onboarding/Onboarding.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      //Testimonial
      {
        path: 'post-testimonial',
        name: 'manage-student-testimonial',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "adm" */ '../views/StudentPortal/Testimonial/PostTestimonial.vue'),
      },

      // Profile Management
      {
        path: 'my-profile',
        name: 'student-my-profile',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Profile/ManageStudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'intro-video',
        name: 'manage-intro-video',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Profile/ManageIntroVideoPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'email-preferences',
        name: 'student-email-preferences',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Profile/ManageEmailPreferences.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      // PIIS / Records & Credentials
      {
        path: 'manage-records',
        name: 'std-manage-records',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Profile/ManageStudentPIIs.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'manage-req-records',
        name: 'care-ready-documents',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Profile/ManageStudentReqPIIs.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      // Resume Management
      {
        path: 'resume',
        name: 'std-manage-resume',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Resume/ManageResume.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      {
        path: 'applied-applications',
        name: 'std-manage-applications',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Scholarships/ManageApplications.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'applied-applications/:id',
        name: 'std-application',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Scholarships/ApplicationForm.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      // Payment List
      {
        path: 'payment-list',
        name: 'std-payment-list',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/MyPayments/MyPayments.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      // Exam Results
      {
        path: 'exam-results',
        name: 'student-exam-results',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/ExamResults/ListExamResults.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'exam-results/add',
        name: 'student-add-exam-result',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/ExamResults/AddExamResult.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'exam-results/edit/:id',
        name: 'student-edit-exam-result',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/ExamResults/AddExamResult.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      // License Verifications
      {
        path: 'licenses',
        name: 'student-license-verifications',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/LicenseVerifications/ListLicenses.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'licenses/add',
        name: 'student-add-license',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/LicenseVerifications/AddLicense.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'licenses/edit/:id',
        name: 'student-edit-license',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/LicenseVerifications/AddLicense.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'my-skillcards',
        name: 'std-profile-skillcard',
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/SkillMap/MySkillCards.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'my-profile/public-view',
        name: 'std-profile-public-view',
        component: () => import(/* webpackChunkName: "std" */ '../views/Students/StudentProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'my-skills',
        name: 'my-skills',
        beforeEnter: premiumPayment,
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Skills/ManageSkillPage.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      // Employers
      {
        path: 'careers/companies',
        name: 'student-employers-list',
        component: () => import(/* webpackChunkName: "std" */ '../views/Employers/Employers.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'employers/:id',
        name: 'student-employer-profile',
        component: () => import(/* webpackChunkName: "std" */ '../views/Employers/EmployerProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },

      // Careers

      // Events (temporarily disabled)
      // {
      //   path: 'events',
      //   component: Layout,
      //   meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      //   children: [
      //     {
      //       path: '',
      //       name: 'student-events',
      //       meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      //       component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Events/EventsListing.vue')
      //     },
      //     {
      //       path: ':id',
      //       name: 'student-event-details',
      //       meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      //       component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Events/EventShowPage.vue')
      //     }
      //   ]
      // },

      {
        path: 'manage-plans',
        name: 'manage-plans',
        component: () => import(/* webpackChunkName: "account" */ '../views/StudentPortal/MyPayments/PlansList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: inAppPaymentGuard,
      },
      {
        path: 'manage-plans/:id',
        name: 'payment-plan-details',
        component: () => import(/* webpackChunkName: "account" */ '../views/StudentPortal/MyPayments/PlanDetails.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        beforeEnter: inAppPaymentGuard,
      },
    ],
  },
  {
    path: '/student/career-pathways',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: 'organizations',
        name: 'student-org-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Careers/OrganizationList.vue'),
      },
      {
        path: 'universities',
        name: 'student-uni-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Careers/UniList.vue'),
      },
      {
        path: '',
        name: 'student-careers',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Careers/Careers.vue'),
      },
      {
        path: ':id',
        name: 'student-career-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Careers/CareerShowPage.vue'),
      },
    ],
  },
  {
    path: '/student/lms',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: 'courses',
        name: 'student-lms-courses',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/LmsCourses/CourseHome.vue'),
      },
    ],
  },
  // Library
  {
    path: '/student/library',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-library',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Library/Library.vue'),
      },
    ],
  },
  // Jobs
  {
    path: '/student/careers/jobs',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: 'featured',
        name: 'student-local-jobs-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Jobs/JobsListing.vue'),
      },
      {
        path: '',
        name: 'student-jobs-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Jobs/JobsListing.vue'),
      },
      {
        path: 'external',
        name: 'student-external-jobs-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Jobs/ExternalJobs/ExternalJobs.vue'),
      },
      {
        path: ':id',
        name: 'student-job-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Jobs/JobShowPage.vue'),
      },
      {
        path: 'featured/:id',
        name: 'student-local-job-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Jobs/JobShowPage.vue'),
      },
    ],
  },
  // Organization student dashboard: Jobs bucket (reuses the standard jobs listing)
  {
    path: '/student/org/jobs',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-org-jobs-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Jobs/JobsListing.vue'),
      },
    ],
  },
  // Research
  {
    path: '/student/careers/research',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-org-research-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Research/ResearchListing.vue'),
      },
      {
        path: ':id',
        name: 'student-research-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Research/ResearchShowPage.vue'),
      },
    ],
  },

  // Events (org dashboard card)
  {
    path: '/student/careers/events',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-org-events-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Events/EventsListing.vue'),
      },
    ],
  },

  // Interviews (org dashboard card)
  {
    path: '/student/careers/org-interviews',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-org-interviews-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        props: { orgScoped: true },
        component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Simulations/SimulationsListing.vue'),
      },
    ],
  },

  // Certifications (org dashboard card)
  {
    path: '/student/careers/certifications',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-org-certifications-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Certifications/CertificationsListing.vue'),
      },
    ],
  },
  {
    path: '/student/sponsorships',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: '',
        name: 'student-scholarships-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Scholarships/ScholarshipsListing.vue'),
      },
      {
        path: ':id',
        name: 'student-scholarship-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () => import(/* webpackChunkName: "std" */ '../views/Scholarships/ScholarshipDetailPage.vue'),
      },
      {
        path: '/application/:id',
        name: 'sponsorship-form',
        component: () => import(/* webpackChunkName: "std" */ '../views/Applications/ApplicationForm.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
    ],
  },
  {
    path: '/student/simulations',
    component: Layout,
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    children: [
      {
        path: 'all',
        name: 'student-simulations-listing',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Simulations/SimulationsListing.vue'),
      },
      {
        path: 'submissions',
        name: 'student-submissions-listing',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Simulations/SimulationSubmissionList.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        path: 'submissions/:id',
        name: 'student-submission-profile',
        component: () => import(/* webpackChunkName: "std" */ '../views/Simulations/SimulationSubmissionProfile.vue'),
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
      },
      {
        // Deep-linked from the LMS for a scenario assignment. Must sit above the
        // ':id' route or it gets matched as a simulation id.
        path: 'scenario-interview',
        name: 'student-scenario-interview',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Simulations/ScenarioInterview.vue'),
      },
      {
        path: ':id',
        name: 'student-simulation-details',
        meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT, USER_ROLES.SCHOOL_ADMIN, USER_ROLES.SCHOOL_OWNER] },
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/StudentPortal/Simulations/SimulationDetail.vue'),
      },
    ],
  },
  {
    path: '/student/attendance',
    name: 'student-attendance',
    meta: { auth: true, rolesRequired: [USER_ROLES.STUDENT] },
    beforeEnter: basicPayment,
    component: () => import(/* webpackChunkName: "std" */ '../views/StudentPortal/Attendance/MyAttendance.vue'),
  },

  {
    path: '/auth',
    name: 'student-auth',
    meta: { auth: false },
    component: () => import(/* webpackChunkName: "std" */ '../views/Auth/DashboardVerification.vue'),
  },
  // beforeEnter: basicPayment,

  // School Public Landing
  {
    path: '/school-landing',
    meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
    component: Layout,
    children: [
      // Home
      {
        path: '',
        name: 'sch-public-home',
        component: () => import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Home/SchlPublicHome.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },

      // Public Jobs
      {
        path: 'jobs',
        name: 'sch-public-jobs',
        component: () => import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Jobs/PublicJobs.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },

      // Public Careers
      {
        path: 'careers',
        name: 'sch-public-careers',
        component: () => import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Careers/PublicCareers.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },

      // Public Resume
      {
        path: 'resume',
        name: 'sch-public-resume',
        component: () => import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Resume/PublicResume.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },

      // Public Resume
      {
        path: 'partnerships',
        name: 'sch-public-parnerships',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Partnerships/PublicPartnerships.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },
      //Public Employer Profile
      {
        path: 'companies/:slug',
        name: 'emp-public-profile',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Employers/PublicEmployerProfile.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },
      // Public Interviews
      {
        path: 'interviews',
        name: 'sch-public-interviews',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Interviews/PublicInterviews.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },
      //Public Testimonials
      {
        path: 'testimonials',
        name: 'sch-public-testimonials',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Testimonials/PublicTestimonialList.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },
      //Public Employers

      {
        path: 'employers',
        name: 'sch-public-employers',
        component: () =>
          import(/* webpackChunkName: "std" */ '../views/SchoolPublicLanding/Employers/PublicEmployers.vue'),
        meta: { auth: false, onlyUnauth: true, onlyUnauthSchool: true },
      },
    ],
  },
  //feedback
  {
    path: '/submit-feedback',
    name: 'submission-feedback',
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/SchoolPublicLanding/Simulations/PublicSimulationFeedback.vue'),
  },
  {
    path: '/submission-feedback-successful/:submission',
    name: 'submission-feedback-success',
    component: () =>
      import(/* webpackChunkName: "adm" */ '../views/SchoolPublicLanding/Simulations/SuccessSimulationComponent.vue'),
  },
];
